
export const decorateEnv = (env) => {
    env.build.buildDate = '20220721104318';
    env.build.buildDateEpoch = 1658400198640;
    env.build.buildRevision = '5b4fecf7d81434199029a7939bf414e3960239ca';
    env.build.project = 'abbottadc';
    env.build.part = 'mgr';
    env.build.deployment = 'prd';
    env.build.viewport = 'pc';
    env.apiRoot = 'https://api-adccrm.abbott.com.cn';
    env.production = 'true';
    env.variables.mapApiKey = 'ee95e52bf08006f63fd29bcfbcf21df0';
};
